// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirmation-container {
  width: 400px;
  min-height: 350px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.alignmsg {
  text-align: center;
}

.bold-txt {
  font-weight: bold;
}

.normal-txt {
  font-weight: normal;
}

.color-BrightBlue {
  color: #005596;
  text-align: center;
}

.nrmlfillbtn {
  border-radius: 0 !important;
  height: 50px;
  font-size: 20px;
  min-width: 150px !important;
  background-color: #005596 !important;
  color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/confirmation-screen/confirmation-screen.component.scss"],"names":[],"mappings":"AACA;EACI,YAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,kBAAA;AAAJ;;AAEA;EACI,iBAAA;AACJ;;AACA;EACI,mBAAA;AAEJ;;AAAA;EACI,cAAA;EACA,kBAAA;AAGJ;;AAAA;EACI,2BAAA;EACF,YAAA;EACE,eAAA;EACA,2BAAA;EACE,oCAAA;EACA,cAAA;AAGN","sourcesContent":["\n.confirmation-container{\n    width: 400px;\n    min-height: 350px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.alignmsg {\n    text-align: center\n}\n.bold-txt{\n    font-weight: bold;\n}\n.normal-txt{\n    font-weight: normal;\n}\n.color-BrightBlue {\n    color: #005596;\n    text-align: center;\n}\n\n.nrmlfillbtn {\n    border-radius: 0 !important;\n  height: 50px;\n    font-size: 20px;\n    min-width: 150px !important;\n      background-color: #005596 !important;\n      color: #ffffff;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
